import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map, switchMap, withLatestFrom } from "rxjs/operators";

import { OnOrbitService } from "../../../services/api/on-orbit.service";
import { OnOrbitActions } from "../../actions/on-orbit.actions";
import { FailState } from "../../models/fail-state";
import { OnOrbitOrderState } from "../../models/on-orbit/on-orbit-order-state";
import { AppState } from "../../reducers";
import { OnOrbitSelectors } from "../../selectors/on-orbit.selectors";

@Injectable()
export class OnOrbitOrderGetEffects {
	get = createEffect(() =>
		this.actions.pipe(
			ofType(OnOrbitActions.order.get),
			withLatestFrom(this.store.select(OnOrbitSelectors.order)),
			switchMap(([action, state]) =>
				this.canUseStoreValue(action, state)
					? of(OnOrbitActions.order.getSuccess(state))
					: of(OnOrbitActions.order.getApi({ orderId: action.orderId }))
			)
		)
	);

	getApi = createEffect(() =>
		this.actions.pipe(
			ofType(OnOrbitActions.order.getApi),
			switchMap((action) =>
				this.onOrbitService.forOrder(action.orderId).pipe(
					map((onOrbits) =>
						OnOrbitActions.order.getSuccess({
							orderOnOrbits: { [action.orderId]: onOrbits },
							loading: false
						})
					),
					catchError((error) => of(OnOrbitActions.order.getFail(new FailState(error))))
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private store: Store<AppState>,
		private onOrbitService: OnOrbitService
	) {}

	private canUseStoreValue(action, state: OnOrbitOrderState): boolean {
		return (
			!_.has(state, "error") &&
			!state.loading &&
			_.has(state, ["orderOnOrbits", action.orderId])
		);
	}
}
